<template>
    <v-app>
        <v-hover>
            <v-navigation-drawer
                :v-model="drawer"
                app
                permanent
                absolute
                hide-overlay
                :temporary="hover && mini"
                slot-scope="{ hover }"
                :mini-variant="mini && !hover"
            >
                <v-toolbar flat class="transparent">
                    <v-list class="pa-0">
                        <v-list-tile v-if="loggedIn" avatar>
                            <v-list-tile-avatar>
                                <img src="/img/jc.png" />
                            </v-list-tile-avatar>

                            <v-list-tile-content>
                                <v-list-tile-title>Norberto</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-toolbar>

                <v-list dense>
                    <v-divider></v-divider>
                    <v-list-tile v-if="loggedIn" to="/resumen">
                        <v-list-tile-action>
                            <v-icon>hourglass_empty</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title>Summary</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-spacer></v-spacer>
                    <v-list-tile @click="gotoLogin">
                        <v-list-tile-action>
                            <v-icon>question_answer</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title v-if="loggedIn">Logout</v-list-tile-title>
                            <v-list-tile-title v-else>Login</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <!-- <v-list-tile v-for="item in menuItems" :key="item.title" :to="{ path: item.link }">
                        <v-list-tile-action>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-tile-action>

                        <v-list-tile-content>
                            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile> -->
                </v-list>
            </v-navigation-drawer>
        </v-hover>

        <v-toolbar app>
            <v-btn icon>
                <v-icon @click="gotoSummary">home</v-icon>
            </v-btn>
            <v-toolbar-title>Dashboard</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon>
                <v-icon @click="gotoLogin">person</v-icon>
            </v-btn>
        </v-toolbar>

        <v-content>
            <v-container fluid>
                <router-view></router-view>
            </v-container>
        </v-content>

        <v-footer app :height="80">
            <v-spacer></v-spacer>
            <img style="height:50px" src="./assets/logoDomotec.png" />
        </v-footer>
    </v-app>
</template>

<script>
export default {
    name: "App",
    components: {},
    data() {
        return {
            drawer: true,
            mini: true,
            right: null,
            hover: true,
            menuItems: [
                // { title: "Home", icon: "dashboard", link: "/home" },
                { title: "Login", icon: "question_answer", link: "/acceso" },
                { title: "Summary", icon: "hourglass_empty", link: "/resumen" }
            ]
        };
    },

    async mounted() {},

    computed: {
        loggedIn() {
            return localStorage.loggedIn;
        }
    },

    methods: {
        gotoLogin() {
            const loginpath = window.location.pathname;
            this.$router.push({ name: "acceso", query: { redirect: loginpath } });
        },

        gotoSummary() {
            this.$router.push("/resumen");
        }
    }
};
</script>

<style>
.v-text-field {
    padding-top: 4px !important;
    margin-top: 2px !important;
}
</style>
